import { createRoutine } from 'redux-saga-routines';

export const fetchSignature = createRoutine('FETCH_SIGNATURE');
